/**
 * axios封装
 */
import axios from 'axios'
import global from './global'
import md5 from 'js-md5'
import { Message } from 'element-ui';
//实例化axios对象
const request = axios.create({
  baseURL: global.ymtApi,
})

//发送请求拦截器
request.interceptors.request.use(async (config) => {
  // console.log(config)
  //发送请求前处理
  const TimeStamp = await getTimestampApi();
  const api = '/api/' + config.url.toLocaleLowerCase()
  console.log(api,'urlll',TimeStamp,'TimeStamp',global.encryStr,'global.encryStr')
  // Sign：MD5(请求uri+时间戳+加密字符串)
  config.headers['Sign'] = md5(api + TimeStamp + global.encryStr)
  // TimeStamp：当前时间戳
  config.headers['TimeStamp'] = TimeStamp
  const token = localStorage.getItem("Token");
  if (token) {
      config.headers['Token'] = token
  }

  return config
}, err => {
  //发送请求错误处理
  return Promise.reject(err)
})
//获取时间戳 --请求失败取客户端时间戳
async  function getTimestampApi(){
  return new Promise((resolve, reject) => {
      axios({
      url: `${global.ymtApi}Common/GetTimeStamp`,
      method: 'GET',
      responseType: 'application/json; charset=utf-8',
      headers: {
        Accept: 'application/json; charset=utf-8'
      },
       data: {},
      }).then(res => {
        if (res.data.ResponseCode==200) {
          resolve(res.data.DomainObj)
        }
        else {
          const timestampJs = getTimestampByJs();
          resolve(timestampJs)
        }
      }).catch(err => {
        const timestampJs = getTimestampByJs();
        resolve(timestampJs)
      })
 
 })
}

function getTimestampByJs() {

 return Math.round(new Date() /1000)

}

request.interceptors.response.use(response => { 
  return response
}, err => { 
  console.log(err ,'err')
  if (err.response != undefined) {
         if (err.response.data.message != '' && err.response.data.message != undefined) {
       }
    }
     else {
      Message.error('系统异常')
    }
})

//导出对象
export default request



// WEBPACK FOOTER //
// ./src/utils/request.js